import { AnimatedHeader } from '@/components/animated-header';
import { FAQItem } from '@/components/faq-item';
import { Footer } from '@/components/footer';
import { Text } from '@/components/text';
import { SCREEN_MAX_WIDTH } from '@/constants/layout';
import { useAnimatedHeader } from '@/hooks/use-animated-header';
import { Image } from 'expo-image';
import { useTranslation } from 'react-i18next';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import Animated from 'react-native-reanimated';

export default function FAQScreen() {
  const { headerTranslateY, scrollHandler, totalHeight } = useAnimatedHeader();
  const { t } = useTranslation();
  const { height: windowHeight } = useWindowDimensions();

  const faqData = t('screens.faq.questions', { returnObjects: true }) as Record<
    string,
    { question: string; answer: string }
  >;
  const questions = Object.entries(faqData || {}).map(([key, value]) => ({
    id: key,
    ...value,
  }));

  return (
    <View style={styles.container}>
      {/* BACKGROUND (Fixed) */}
      <View style={[styles.backgroundContainer, { height: windowHeight }]}>
        <Image
          source={require('@/assets/images/background-l.webp')}
          style={styles.backgroundImage}
          contentFit='cover'
          alt={t('common.backgroundAlt', 'Abstract decorative background')}
        />
      </View>

      <Animated.ScrollView
        onScroll={scrollHandler}
        scrollEventThrottle={16}
        style={styles.scrollView}
        contentContainerStyle={{
          paddingTop: totalHeight + 40,
        }}>
        <View style={styles.content}>
          <Text type='title' className='text-center mb-10 text-black'>
            {t('screens.faq.title', 'Frequently Asked Questions')}
          </Text>

          <View className='w-full'>
            {questions.map((item, index) => (
              <FAQItem key={item.id} question={item.question} answer={item.answer} index={index} />
            ))}
          </View>
        </View>
        <Footer />
      </Animated.ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#E3E3E3',
  },
  scrollView: {
    flex: 1,
    width: '100%',
    backgroundColor: 'transparent',
  },
  backgroundContainer: {
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 0,
  },
  backgroundImage: {
    flex: 1,
    width: '100%',
  },
  content: {
    maxWidth: SCREEN_MAX_WIDTH,
    alignSelf: 'center',
    paddingHorizontal: 24,
    width: '100%',
    marginBottom: 60,
  },
});
